// extracted by mini-css-extract-plugin
export default {"selector":"_64lE8SD0w9f6V+jyqMQzRQ=="};